import Genome from "../../assets/img/Service/Service-Genome.png";
import Effet_Mer from "../../assets/img/Service/Service-Effet_Mer.png";
import Maison_Marline from "../../assets/img/Service/Service-Maison_Marline.png";
import People from "../../assets/img/Service/Service-People.png";
import { useTranslation } from "react-i18next";
import Arrow from "../../assets/img/Ico/Arrow.svg";
import { Link } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Project() {
  const { t } = useTranslation();
  const projectsRef = useRef(null);
  const buttonRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation des cartes de projet avec stagger
      gsap.fromTo(
        projectsRef.current.children,
        {
          y: 50,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.2,
          scrollTrigger: {
            trigger: projectsRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation du bouton après les cartes
      gsap.fromTo(
        buttonRef.current,
        {
          y: 30,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          delay: 1.2, // Attendre la fin des cartes (4 * 0.2 + 0.8)
          scrollTrigger: {
            trigger: buttonRef.current,
            start: "top 90%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="Services-Project-Page">
      <h2 className="Services-Project-Title">{t("servicesProject.title")}</h2>
      <div ref={projectsRef} className="Services-Project-Image">
        <Link to="/genome" className="Project-Link">
          <div className="Project-Card-Container">
            <div className="Project-Card">
              <img src={Genome} className="Project-Card-Image" alt="Genome" />
            </div>
            <div className="Project-Hover-Text">
              <span>Genome</span>
              <span className="Project-Arrow">
                <img
                  src={Arrow}
                  className="chevron arrow"
                  alt={t("footer.altToggle")}
                />
              </span>
            </div>
          </div>
        </Link>
        <Link to="/effet_mer" className="Project-Link">
          <div className="Project-Card-Container">
            <div className="Project-Card">
              <img
                src={Effet_Mer}
                className="Project-Card-Image"
                alt="Effet Mer"
              />
            </div>
            <div className="Project-Hover-Text">
              <span>Effet Mer</span>
              <span className="Project-Arrow">
                <img
                  src={Arrow}
                  className="chevron arrow"
                  alt={t("footer.altToggle")}
                />
              </span>
            </div>
          </div>
        </Link>
        <Link to="/maison_marline" className="Project-Link">
          <div className="Project-Card-Container">
            <div className="Project-Card">
              <img
                src={Maison_Marline}
                className="Project-Card-Image"
                alt="Maison Marline"
              />
            </div>
            <div className="Project-Hover-Text">
              <span>Maison Marline</span>
              <span className="Project-Arrow">
                <img
                  src={Arrow}
                  className="chevron arrow"
                  alt={t("footer.altToggle")}
                />
              </span>
            </div>
          </div>
        </Link>
        <Link to="/people" className="Project-Link">
          <div className="Project-Card-Container">
            <div className="Project-Card">
              <img src={People} className="Project-Card-Image" alt="People" />
            </div>
            <div className="Project-Hover-Text">
              <span>People</span>
              <span className="Project-Arrow">
                <img
                  src={Arrow}
                  className="chevron arrow"
                  alt={t("footer.altToggle")}
                />
              </span>
            </div>
          </div>
        </Link>
      </div>

      <Link
        to="/projects"
        // ref={buttonRef}
        rel="noreferrer"
        className="websiteBtn thin"
      >
        {t("servicesProject.button")}
      </Link>
    </div>
  );
}
